//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React, {
  createContext,
  MutableRefObject,
  ReactNode,
  useContext,
} from 'react';

export interface DialogContextProps {
  contentRef: MutableRefObject<HTMLDivElement | null>;
}

export interface DialogContextProviderProps {
  children: ReactNode;
  contentRef: MutableRefObject<HTMLDivElement | null>;
}

/*
  In some cases, the `Radix UI Dialog` does not work with certain components, such as `Popover` component.
  To resolve this issue, we should append the popover target to the `Dialog` content. We use this context to provide the content ref.
*/
export const DialogContext = createContext<DialogContextProps>({
  contentRef: { current: null },
});

export const useDialogContext = () => useContext(DialogContext);

export const DialogContextProvider = ({
  children,
  contentRef,
}: DialogContextProviderProps) => (
  <DialogContext.Provider value={{ contentRef }}>
    {children}
  </DialogContext.Provider>
);
